import { Routes } from '@angular/router';
import { AdminModule } from './admin/module/admin.module';
import { MunicipalityModule } from './municipality/module/municipality.module';
import { PublicModule } from './public/module/public.module';

export const routes: Routes = [
    
  { path: 'admin', loadChildren: () => import('./admin/module/admin.module').then(m => m.AdminModule) },
  { path: 'secure', loadChildren: () => import('./municipality/module/municipality.module').then(m => m.MunicipalityModule) },
  { path: 'appeal', loadChildren: () => import('./public/module/public.module').then(m => m.PublicModule) }

];